/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSandbox = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      fill={fill}
      viewBox="0 0 26 22"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 22px;
      `}
      {...props}
    >
      <path
        stroke={stroke}
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M12.989 1.571L1.57 8.43 13 15.286l11.429-6.857-11.44-6.858z"
      />
      <path
        stroke={stroke}
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M19.663 11.286l-6.674-4-6.663 3.988m-4.755 2.869V8.429L13 15.286V21L1.571 14.143zm22.858 0V8.429L13 15.286V21l11.429-6.857z"
      />
    </svg>
  ),
);
